import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SCRIPTS_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { ScriptsComponent } from './scripts/scripts.component';

const routes: Routes = [
  {
    path: SCRIPTS_ROUTE,
    component: ScriptsComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScriptsRoutingModule {}
